export  const defaultSummaryBody = [
    {
      patient_info: {
        name: "John Doe",
        age: 45,
        gender: "Male",
        ethnicity: "Caucasian",
      },
      medical_history: [
        {
          condition: "Hypertension",
          diagnosis_date: "2015-06-15",
        },
        {
          condition: "Type 2 Diabetes",
          diagnosis_date: "2018-09-10",
        },
      ],
      medications: [
        {
          name: "Metformin",
          dosage: "500mg",
          frequency: "Twice a day",
          start_date: "2018-09-15",
        },
      ],
      allergies: [
        {
          substance: "Penicillin",
          reaction: "Rash",
        },
      ],
      vital_signs: [
        {
          date: "2024-05-12",
          blood_pressure: "130/85",
          heart_rate: 75,
          temperature: "98.6",
          respiratory_rate: 18,
        },
      ],
      recent_visits: [
        {
          date: "2024-04-20",
          reason: "Follow-up for diabetes",
          outcome: "Adjusted medication",
        },
      ],
      lab_results: [
        {
          date: "2024-04-18",
          test: "HbA1c",
          result: "7.2%",
        },
      ],
      imaging_reports: [
        {
          date: "2024-01-10",
          study: "Chest X-ray",
          summary: "No significant findings",
        },
      ],
      wearable_data: {
        activity: "7000 steps per day",
        heart_rate_trend: "Average 72 bpm",
        sleep_pattern: "7 hours per night",
      },
      lifestyle: {
        smoking_status: "Non-smoker",
        alcohol_consumption: "Moderate",
        diet: "Balanced",
        exercise: "Regular",
      },
    },
  ];
 export  const cardioVascularData=["Assessing cardiovascular risk by analyzing patient data, including cholesterol levels and blood pressure.",
"Evaluating genetic predispositions and lifestyle factors to predict potential heart-related issues.",
"Integrating ECG results, heart rate, and symptoms for a comprehensive cardiovascular risk assessment.",
"Providing data-driven insights to support early intervention and prevention of cardiovascular conditions."]
export const losPrediction =["Analyzing patient demographics, medical history, and treatment plans to predict hospital length of stay.",
"Evaluating clinical data such as diagnosis, procedures, and comorbidities to estimate recovery time.",
"Integrating lab results, vital signs, and response to treatments for accurate length of stay predictions.",
"Supporting healthcare planning by providing insights into expected discharge timelines based on patient data."]

export const symptomPrediction=["Analyzing patient demographics, medical history, and current conditions to predict health outcomes.",
"Evaluating risk factors such as age, lifestyle, and comorbidities to anticipate potential complications.",
"Integrating lab results, symptoms, and treatment responses for accurate patient outcome predictions.",
"Supporting clinical decision-making by providing data-driven insights into future patient health trajectories."]

export const patientReadmissonPrediction =["Analyzing patient history, previous admissions, and discharge details to predict the likelihood of readmission.",
"Evaluating factors such as comorbidities, treatment outcomes, and follow-up care to assess readmission risk.",
"Integrating clinical data, recovery progress, and post-discharge complications for accurate readmission predictions.",
"Providing insights to healthcare providers to reduce readmission rates by identifying high-risk patients early."]

export  const summary = [
    "Creating a comprehensive medical summary based on provided health records.",
    "Focusing on diagnosis, treatment history, and medications to gain insights.",
    "Comparing lab results with symptoms and doctor notes for accuracy.",
    "Integrating various health records to form a complete medical overview.",
    "Assisting in making informed medical decisions through thorough data analysis.",
  ];
  export  const sampleData = [
    "Creating a comprehensive medical summary based on provided health records.",
    "Focusing on diagnosis, treatment history, and medications to gain insights.",
    "Comparing lab results with symptoms and doctor notes for accuracy.",
    "Integrating various health records to form a complete medical overview.",
    "Assisting in making informed medical decisions through thorough data analysis.",
  ];
   export  const homeCareRequest = [
    " Identifies specific medical and personal care requirements.",
    "Allocates healthcare personnel and necessary supplies effectively.",
    "Facilitates communication among providers, patients, and families.",
    "Regularly evaluates care quality and adjusts plans as needed.",
  ];
  export  const transportRequest = [
    " Ensures timely transportation of patients to destination.",
    "Involves scheduling vehicles and staff for seamless operations.",
    "Adheres to safety regulations and protocols for secure transport.",
    "Maintains records for accountability and service improvement.",
  ];
  export  const logisticRequest = [
     " Ensures timely transportation and delivery of logistics to destination.",
    "Involves scheduling vehicles and logistics for seamless operations and delivery.",
    "Adheres to safety regulations and protocols for secure transport.",
    "Maintains records for accountability and service improvement.",
  ];

  export const HealthConnectApps = {
  AI_SUMMARY: {
    name: "HealthConnect AI Summary",
    description: "The HealthConnect AI Summary app uses AI to generate a detailed and comprehensive overview of a patient’s health record. By analyzing patient data, medical history, and recent encounters, the AI provides an insightful summary that highlights critical health information and potential concerns."
  },
  AI_CARDIOVASCULAR: {
    name: "HealthConnect AI Cardiovascular",
    description: "The HealthConnect AI Cardiovascular app utilizes AI algorithms to assess cardiovascular health risks. By analyzing vital signs such as blood pressure, cholesterol levels, and heart rate trends, the AI provides predictions and preventive measures to help manage and improve heart health."
  },
  AI_LENGTH_OF_STAY: {
    name: "HealthConnect AI Length of Stay Predictor",
    description: "The HealthConnect AI Length of Stay Predictor app uses AI to forecast the expected length of hospital stay for patients. By examining medical conditions, treatment plans, and historical data, the AI provides accurate predictions that assist in resource planning and patient management."
  },
  AI_READMISSION_RISK: {
    name: "HealthConnect AI Readmission Risk",
    description: "The HealthConnect AI Readmission Risk app employs AI to evaluate the likelihood of patient readmission. By analyzing factors such as past medical history, treatment adherence, and demographic data, the AI predicts potential readmissions, enabling healthcare providers to implement preventive strategies."
  },
  AI_SYMPTOM_ANALYZER: {
    name: "HealthConnect AI Symptom Analyzer",
    description: "The HealthConnect AI Symptom Analyzer app allows healthcare providers to input patient symptoms, and the AI generates potential diagnoses by comparing the symptoms with past medical records and historical data. This AI-driven tool aids in the quick identification of possible health conditions based on the patient’s symptoms."
  },
 LOGISTICS_TRANSPORT: {
    name: "HealthConnect Transportation Assistance",
    description: "The HealthConnect Transportation Assistance app is designed to support patients in arranging transportation for medical appointments. This app integrates with any EHR system to offer seamless scheduling of rides, ensuring that patients have reliable transportation to and from healthcare facilities."
  },
  LOGISTIC_HOME_CARE: {
    name: "HealthConnect Home Care Support",
    description: "The HealthConnect Home Care Support app assists healthcare providers in coordinating and managing home care services for patients. It streamlines the process of scheduling home visits, ensuring that patients receive timely and effective care in the comfort of their homes."
  },
  LOGISTICS_EQUIPMENT_DELIVERY: {
    name: "HealthConnect Equipment Delivery Coordination",
    description: "The HealthConnect Equipment Delivery Coordination app facilitates the timely delivery of medical equipment to patients. It allows healthcare providers to track and manage the delivery process, ensuring that patients receive the necessary equipment promptly for their treatment."
  }

};
export const referralSections = [
  {
    title: "Streamlined Referral Creation",
    description: "Easily create and manage outgoing referrals with intuitive forms and select specialties and input diagnosis codes effortlessly."
  },
  {
    title: "Secure Provider Communication",
    description: "Facilitate real-time, secure messaging between referring and receiving providers and Ensure seamless collaboration and follow-ups for patient care."
  },
  {
    title: "Accurate Patient Visit Details",
    description: "Automatically include accurate and up-to-date patient visit information in each referral and  reduce manual entry and minimize errors."
  },
  {
    title: "Insurance Validation",
    description: "Confirm insurance coverage acceptance before sending out referrals and prevent delays caused by insurance issues."
  },
  {
    title: "Specialty Selection",
    description: "Choose the appropriate medical specialty for referrals from a predefined list and ensure patients are directed to the right specialists."
  },
  {
    title: "Referral Tracking",
    description: "Track the status of outgoing referrals and receive notifications on updates and stay informed about referral acceptance and scheduling."
  }
];
export const carePlanSections = [
  {
    title: "Provider Notes",
    description: "Input detailed provider notes that serve as the foundation for the care plan and outline observations, assessments, and patient needs."
  },
  {
    title: "Goals Creation",
    description: "Break down the provider's notes into clear, achievable goals and set specific, measurable targets for the patient’s treatment and recovery."
  },
  {
    title: "Task Assignment",
    description: "Define tasks based on the established goals and assign actionable steps that guide both the patient and care team in achieving the care plan's objectives."
  },
  {
    title: "Goal and Task Selection",
    description: "Select the relevant goals and tasks that align with the patient's treatment plan and tailor the care plan to the patient's unique health needs."
  },
  {
    title: "Care Plan Creation",
    description: "Compile the selected goals and tasks into a comprehensive care plan and ensure all components are organized for easy reference and execution."
  },
  {
    title: "Patient Engagement",
    description: "Communicate the care plan to the patient and provide guidance on their role and responsibilities to support adherence and successful outcomes."
  }
];


export const specialties = [
  { value: 'infectiousDisease', label: 'Infectious Disease' },
  { value: 'neurology', label: 'Neurology' },
  { value: 'obstetrics', label: 'Obstetrics' },
  { value: 'oncology', label: 'Oncology' },
  { value: 'pulmonary', label: 'Pulmonary' },
  { value: 'renal', label: 'Renal' },
  { value: 'rheumatology', label: 'Rheumatology' },
  { value: 'trauma', label: 'Trauma' },
  { value: 'primaryCare', label: 'Primary care' },
];

export const hospitalNames = [
  { label: 'Cleveland Clinic', value: 'Cleveland Clinic' },
  { label: 'NYU Langone Hospitals', value: 'NYU Langone Hospitals' },
  { label: 'The Johns Hopkins Hospital', value: 'The Johns Hopkins Hospital' },
  { label: 'Massachusetts General Hospital', value: 'Massachusetts General Hospital' },
];
export const intialFormData={  Pickup: "",
                      Destination: "",
                      dateTime: "",
                      transportType: "",
                      transportUrgency:"",
                      contactInfo: "",
                      homeCareType: "",
                      requestedDate: "",
                      careDuration: "",
                      caregiverPreferences: "",
                      medicalConditions: "",
                      equipmentNeeded: "",
                      equipmentType: "",
                      deliveryAddress: "",
                      deliveryDate: "",
                      installationNeeds: "",
                      rentalInformation: "",
                    }

                     export const embedApps = [
    {
      title: "HealthConnect AI Medical Summary",
      desc: "The HealthConnect AI Medical Summary app leverages artificial intelligence to generate a detailed summary of a patient’s health records. By analyzing medical history, recent encounters, and clinical data, it highlights key health information and potential concerns, providing healthcare professionals with a comprehensive and insightful overview of the patient’s health.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-ai-medical-summary",
    },
    {
      title: "HealthConnect AI Cardiovascular Risk Prediction",
      desc: "The HealthConnect AI Cardiovascular app employs AI algorithms to assess cardiovascular health risks. By analyzing vital signs such as blood pressure, cholesterol, and heart rate trends, this tool helps predict cardiovascular risks and suggests preventive measures to support heart health management and improvement.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-ai-cardiovascular-risk-prediction",
    },
    {
      title: "HealthConnect AI Length of Stay Predictor",
      desc: "The HealthConnect AI Length of Stay Predictor uses AI to forecast the duration of hospital stays. By analyzing factors like medical conditions, treatment plans, and historical patient data, the app provides accurate predictions, aiding healthcare providers in resource allocation and patient management.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-ai-length-of-stay-predictor",
    },
    {
      title: "HealthConnect AI Patient Readmission Risk",
      desc: "The HealthConnect AI Readmission Risk app utilizes AI to predict the likelihood of patient readmission. By assessing factors such as medical history, treatment adherence, and demographics, healthcare providers can proactively implement preventive strategies to reduce readmissions and improve patient outcomes.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-ai-patient-readmission-risk",
    },

    {
      title: "HealthConnect AI Patient Symptom Analyzer",
      desc: "The HealthConnect AI Symptom Analyzer allows healthcare providers to input patient symptoms and generates potential diagnoses by comparing them to historical data and medical records. This AI-driven tool facilitates quicker and more accurate identification of health conditions, helping guide clinical decision-making.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-ai-patient-symptom-analyzer",
    },
    {
      title: "HealthConnect Patient Questionnaire Form ",
      desc: "The HealthConnect Patient Questionnaire Form app provides a simple, customizable questionnaire interface for healthcare providers. It streamlines the data collection process by using pre-defined templates tailored to specific needs, ensuring accurate and efficient capture of vital patient information.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-patient-questionnaire-form",
    },
    {
      title: "HealthConnect-AI-Powered Chat-Based Questionnaire ",
      desc: "Interactive AI-Driven Patient Questionnaire Chatbot. This app integrates an AI-powered chatbot within the HealthConnect platform, engaging patients through dynamic, personalized conversations. It asks pre-defined and adaptive questions based on patient responses, providing a more human-like interaction. This tool enhances data collection and patient engagement, especially for gathering feedback and monitoring adherence.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-ai-powered-chat-based-questionnaire",
    },
    {
      title: "HealthConnect Patient Referral Manager",
      desc: "The HealthConnect Referral Workflow Manager simplifies the referral process by allowing healthcare providers to efficiently create and manage referrals within any EHR system. It facilitates the selection of specialties, entering diagnosis codes, secure provider communication, and ensuring insurance acceptance—all while streamlining the entire workflow.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-patient-referral",
    },
    {
      title: "HealthConnect Patient Logistics Service",
      desc: "The HealthConnect Transportation Assistance app helps patients arrange transportation to and from medical appointments. Integrated with EHR systems, it allows for seamless ride scheduling, ensuring patients have reliable transportation for their healthcare needs.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-patient-logistics-service",
    },
    {
      title: "HealthConnect-AI-Powered Call Bot for Patient Questionnaires",
      desc: "Conversational AI-Driven Call Bot for Patient Engagement This AI-powered call bot engages patients through conversational, interactive calls. It uses pre-defined or dynamic questions to gather feedback, track adherence, and enhance patient engagement by simulating a natural, human-like conversation. This hands-free solution provides an efficient way to collect detailed information within the HealthConnect platform.",
      nav: "https://apps.smarthealthit.org/app/healthconnect-ai-powered-call-bot-for-patient-questionnaires",
    },
    {
      title: "HealthConnect AI - Patient Care Plan Generator",
      desc: "The HealthConnect AI - Patient Care Plan Generator app offers healthcare providers a powerful tool to generate personalized, data-driven care plans for patients. Using SMART on FHIR standards, this application seamlessly integrates into your existing EHR workflows, ensuring efficient and informed decision-making",
    },
  ];
